import { Button as MuiButton, styled } from "@mui/material";

import { withDefaultProps } from "fond/utils/withDefaultProps";

const SmallFullWidthButton = withDefaultProps(MuiButton, { size: "small", fullWidth: true });
export const Button = styled(SmallFullWidthButton)(({ theme }) => ({
  justifyContent: "flex-start",
  fontSize: theme.typography.size.small,
  lineHeight: "12px",
  color: theme.palette.text.primary,
  "&:not(.Mui-disabled) svg": {
    color: theme.palette.primary.main,
  },
}));
